/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const TimestampGreaterThan: core.serialization.ObjectSchema<
    serializers.TimestampGreaterThan.Raw,
    Truvity.TimestampGreaterThan
> = core.serialization.object({
    value: core.serialization.date(),
});

export declare namespace TimestampGreaterThan {
    export interface Raw {
        value: string;
    }
}
